import {UpmPlant, useUpmPlantsContext} from '@hconnect/upm'

import {useSuiteHierarchyId} from './useSuiteHierarchyId'

/**
 * Non-throwing variant of usePlantFromHierarchyId for features that also render on non-plant
 * hierarchy nodes (e.g. area dashboards).
 *
 * @returns undefined while UPM plants are loading, the UpmPlant when the URL hierarchyId is a
 * plant node, otherwise null (no hierarchyId, or a non-plant node such as an area)
 */
export const useUpmPlantFromHierarchyId = (): UpmPlant | null | undefined => {
  const hierarchyId = useSuiteHierarchyId()
  const plantsMap = useUpmPlantsContext({isInitialLoad: true})

  if (!plantsMap) {
    return undefined
  }

  return Object.values(plantsMap).find(({upmId}) => upmId === hierarchyId) ?? null
}
